import {
  Box,
  Paper,
  Typography,
  TextField,
  Grid,
  Stack,
  Alert,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const EducationStep = ({
  profileData,
  handleInputChange,
  currentDegree,
  setCurrentDegree,
  initialDegreeState,
  currentPostGrad,
  setCurrentPostGrad,
  initialPostGradState,
  currentDiploma,
  setCurrentDiploma,
  initialDiplomaState,
  handleAddItem,
  handleDeleteItem,
  validationErrors,
}) => {
  const theme = useTheme(); // CHANGED: Instantiate theme

  // CHANGED: Removed all local style objects (sectionPaperStyle, sectionTitleStyle, etc.)

  const handleDynamicChange = (setter, state, field, value) => {
    setter({ ...state, [field]: value });
  };

  // A reusable style for the paper sections, now using theme variables
  const paperSectionStyles = {
    p: 3,
    border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    borderRadius: "20px",
    boxShadow: theme => `0 4px 20px ${alpha(theme.palette.common.black, 0.05)}`,
    backgroundColor: "background.paper",
  };


  return (
    <Box>
      {validationErrors && validationErrors.education && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {validationErrors.education}
        </Alert>
      )}

      <Stack spacing={3}>
        <Paper sx={paperSectionStyles}>
          <Typography
            variant="h6"
            // CHANGED: Replaced sx object with theme-aware values
            sx={{ color: "primary.main", fontWeight: "600", mb: 3 }}
          >
            Post Graduation
          </Typography>
          <List>
            {profileData.post_graduate_details &&
              profileData.post_graduate_details.map((item, index) => (
                <ListItem
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      color="error"
                      onClick={() =>
                        handleDeleteItem("post_graduate_details", index)
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={item.course_name}
                    secondary={`${item.institution_name} - ${item.year_passing}`}
                  />
                </ListItem>
              ))}
          </List>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Course Name"
                // CHANGED: sx prop removed, styles come from global theme
                value={currentPostGrad.course_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentPostGrad,
                    currentPostGrad,
                    "course_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Institution Name"
                value={currentPostGrad.institution_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentPostGrad,
                    currentPostGrad,
                    "institution_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Specialization"
                value={currentPostGrad.specialization || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentPostGrad,
                    currentPostGrad,
                    "specialization",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Year of Passing"
                value={currentPostGrad.year_passing || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentPostGrad,
                    currentPostGrad,
                    "year_passing",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Score / CGPA"
                value={currentPostGrad.score || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentPostGrad,
                    currentPostGrad,
                    "score",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                // CHANGED: Replaced sx prop with color prop and specific height
                color="primary"
                sx={{ height: "56px" }}
                fullWidth
                onClick={() => {
                  handleAddItem("post_graduate_details", currentPostGrad);
                  setCurrentPostGrad(initialPostGradState);
                }}
              >
                Add Post Graduation
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={paperSectionStyles}>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: "600", mb: 3 }}
          >
            Graduation{" "}
            {/* CHANGED: Replaced hardcoded red with theme error color */}
            <span style={{ color: theme.palette.error.main }}>*</span>
          </Typography>
          <List>
            {profileData.degree_details &&
              profileData.degree_details.map((item, index) => (
                <ListItem
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      color="error"
                      aria-label="delete"
                      onClick={() => handleDeleteItem("degree_details", index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={item.degree_name}
                    secondary={`${item.institution_name} - ${item.year_passing}`}
                  />
                </ListItem>
              ))}
          </List>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Degree Name"
                value={currentDegree.degree_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDegree,
                    currentDegree,
                    "degree_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Institution Name"
                value={currentDegree.institution_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDegree,
                    currentDegree,
                    "institution_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Specialization"
                value={currentDegree.specialization || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDegree,
                    currentDegree,
                    "specialization",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Year of Passing"
                value={currentDegree.year_passing || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDegree,
                    currentDegree,
                    "year_passing",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Score / CGPA"
                value={currentDegree.score || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDegree,
                    currentDegree,
                    "score",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                color="primary"
                sx={{ height: "56px" }}
                fullWidth
                onClick={() => {
                  handleAddItem("degree_details", currentDegree);
                  setCurrentDegree(initialDegreeState);
                }}
              >
                Add Degree
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={paperSectionStyles}>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: "600", mb: 3 }}
          >
            Diplomas
          </Typography>
          <List>
            {profileData.diploma_details &&
              profileData.diploma_details.map((item, index) => (
                <ListItem
                  key={index}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      color="error"
                      aria-label="delete"
                      onClick={() => handleDeleteItem("diploma_details", index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={item.course_name}
                    secondary={`${item.institution_name} - ${item.year_passing}`}
                  />
                </ListItem>
              ))}
          </List>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Course Name"
                value={currentDiploma.course_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDiploma,
                    currentDiploma,
                    "course_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Institution Name"
                value={currentDiploma.institution_name || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDiploma,
                    currentDiploma,
                    "institution_name",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Specialization"
                value={currentDiploma.specialization || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDiploma,
                    currentDiploma,
                    "specialization",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Year of Passing"
                value={currentDiploma.year_passing || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDiploma,
                    currentDiploma,
                    "year_passing",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Score / Percentage"
                value={currentDiploma.score || ""}
                onChange={(e) =>
                  handleDynamicChange(
                    setCurrentDiploma,
                    currentDiploma,
                    "score",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                color="primary"
                sx={{ height: "56px" }}
                fullWidth
                onClick={() => {
                  handleAddItem("diploma_details", currentDiploma);
                  setCurrentDiploma(initialDiplomaState);
                }}
              >
                Add Diploma
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={paperSectionStyles}>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: "600", mb: 3 }}
          >
            12th HSC Details
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="College Name"
                value={profileData.twelfth_college_name || ""}
                onChange={(e) =>
                  handleInputChange("twelfth_college_name", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Board Name"
                value={profileData.twelfth_board_name || ""}
                onChange={(e) =>
                  handleInputChange("twelfth_board_name", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Year of Passing"
                value={profileData.twelfth_year_passing || ""}
                onChange={(e) =>
                  handleInputChange("twelfth_year_passing", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Score / Percentage"
                value={profileData.twelfth_score || ""}
                onChange={(e) =>
                  handleInputChange("twelfth_score", e.target.value)
                }
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={paperSectionStyles}>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: "600", mb: 3 }}
          >
            10th SSC Details{" "}
            <span style={{ color: theme.palette.error.main }}>*</span>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                required
                label="School Name"
                value={profileData.tenth_school_name || ""}
                onChange={(e) =>
                  handleInputChange("tenth_school_name", e.target.value)
                }
                error={!!validationErrors.tenth_school_name}
                helperText={validationErrors.tenth_school_name || ""}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                required
                label="Board Name"
                value={profileData.tenth_board_name || ""}
                onChange={(e) =>
                  handleInputChange("tenth_board_name", e.target.value)
                }
                error={!!validationErrors.tenth_board_name}
                helperText={validationErrors.tenth_board_name || ""}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                required
                label="Year Of Passing"
                value={profileData.tenth_year_passing || ""}
                onChange={(e) =>
                  handleInputChange("tenth_year_passing", e.target.value)
                }
                error={!!validationErrors.tenth_year_passing}
                helperText={validationErrors.tenth_year_passing || ""}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                required
                label="Score / Percentage"
                value={profileData.tenth_score || ""}
                onChange={(e) =>
                  handleInputChange("tenth_score", e.target.value)
                }
                error={!!validationErrors.tenth_score}
                helperText={validationErrors.tenth_score || ""}
              />
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </Box>
  );
};

export default EducationStep;
